import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Card from '../components/Card';
import pizza from '../imges/pizza.png'
import { BASE_URL } from './helper'

export default function Home() {
    const [search, setsearch] = useState('');
    const [foodItem, setfoodItem] = useState([]);
    const [foodCat, setfoodCat] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadData = async () => {
        let response = await fetch(`${BASE_URL}/api/foodData`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            }
        });

        response = await response.json();
        setfoodItem(response[0]);
        setfoodCat(response[1]);
        setIsLoading(false);
        // console.log(response[0], response[1]);
    }

    useEffect(() => {
        loadData()
    }, [])




    return (
        <>
            <Header />
            <div>
                <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div class="carousel-inner" id='carousel'>
                        <div class="carousel-caption">
                            <div class="d-flex justify-content-center">
                                <input class="form-control" type="search" placeholder="Search" aria-label="Search" value={search} onChange={(e) => { setsearch(e.target.value) }} />
                                {/* <button class="btn btn-outline-success" type="submit">Search</button> */}
                            </div>
                        </div>
                        <div class="carousel-item active">
                            <img src={pizza} class="img d-block w-100" alt="pizza" />
                        </div>
                        <div class="carousel-item">
                            <img src="https://source.unsplash.com/random/500x250/?sandwich" class="img d-block w-100" alt="..." />
                        </div>
                        <div class="carousel-item">
                            <img src="https://source.unsplash.com/random/500x250/?pizza" class="img d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div className='container'>
                {isLoading ? (
                    <div className='row pb-5'>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> // Show loading skeleton while data is loading
                ) : (
                    foodCat.length > 0 ? (
                        foodCat.map((catData) => (
                            <div className='row mb-3' key={catData._id}>
                                <div className='fs-3' style={{ color: '#fff', padding: '5px 12px 5px' }}>
                                    {catData.CategoryName}
                                </div>
                                <hr style={{ color: '#fff' }} />
                                {foodItem.length > 0 ? (
                                    foodItem
                                        .filter((itemData) => (itemData.CategoryName === catData.CategoryName) && (itemData.name.toLowerCase().includes(search.toLowerCase())))
                                        .map((filterItem) => (
                                            <div key={filterItem._id} className='col-12 col-lg-3 col-md-6 col-sm-9 all-card'>
                                                <Card
                                                    foodItem={filterItem}
                                                    options={filterItem.options[0]}
                                                />
                                            </div>
                                        ))
                                ) : (
                                    <div>No such data found</div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div>No data available</div>
                    )
                )}
            </div>
            <Footer />
        </>
    )
}
